var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuantower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 2500,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "6 6 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00566c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 6C117.632 6 6 117.632 6 256c0 137.899 111.632 250 250 250 137.899 0 250-111.632 250-250C505.531 117.632 393.899 6 256 6zm143.058 414.165V304.78l-78.33-9.38v168.386c-7.974 2.345-15.948 4.222-24.39 6.098V267.257l102.72 16.417v-62.383L256 177.67l-143.058 43.621v62.852l102.72-16.417v202.627c-8.442-1.407-16.416-3.753-24.39-6.098V295.869l-78.33 9.381v115.384C66.976 380.765 37.895 321.666 37.895 256c0-120.544 97.561-218.105 218.105-218.105S474.105 135.456 474.105 256c0 65.666-29.081 124.296-75.047 164.165z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.058 205.343v-30.956L256 114.818l-143.527 59.569v30.956L256 156.563z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 94.18l97.561 43.621V109.19L256 59.471l-98.03 49.719v28.611z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantower);
export default __webpack_public_path__ + "static/media/quantower.e2dbe750b2407bed60f3cfcb26c63950.svg";
export { ForwardRef as ReactComponent };